import React from 'react'
import NavBar from '../NavBar.component'
import Slider from '../Slider.component'
import Footer from '../Footer.component'

import Banner4 from "../../assets/Banner4.svg";
import Clientele from '../Home/Clientele.component'
import CustomScrollbar from '../CustomScrollbar.component'
import SswayamERPInventoryManagement from './SswayamERPInventoryManagement.component';
import SswayamERPProductManagement from './SswayamERPProductManagement.component';
import SswayamERPFeedbackManagement from './SswayamERPFeedbackManagement.component';
import SswayamERPSales from './SswayamERPSales.component';
import SswayamERPSarvice from './SswayamERPSarvice.component';

export default function SswayamCrmErp() {
    return (
        <>
            <section className="">
                {/* NAVIGATION BAR */}
                <section className="">
                    <NavBar />
                </section>

                {/* NAV-CONTACT */}
                <section>{/* <NavContact/> */}</section>

                {/* HERO SLIDER */}
                <section>
                    <Slider images={[Banner4]} showDemoButton={true} />
                </section>

                <section>
                    <SswayamERPInventoryManagement />
                    <SswayamERPProductManagement />
                    <SswayamERPFeedbackManagement />
                    <SswayamERPSales />
                    <SswayamERPSarvice />
                </section>

                <section>
                    <Clientele />
                </section>

                <section>
                    <Footer />
                </section>

                <CustomScrollbar />
            </section>
        </>
    )
}
